import React from "react";
import { NotFoundError } from "../../../../utils/error";
import { ProductContext } from "./context";
import { getQuery, QueryVariables, useParseResponse } from "./queryHelper";

interface IProviderProps {
  variables: QueryVariables;
}

interface QueryResponse {
  loading: boolean;
  error: Error;
  data: any;
}

const { Provider } = ProductContext;

export const ProductContextProvider: React.FC<IProviderProps> = ({ children, variables }) => {
  const isOffer = Boolean(variables.offerIds);
  const Query = getQuery(isOffer);
  const parseResponse = useParseResponse(isOffer, variables);

  return (
    <Query variables={variables}>
      {({ loading, error, data }: QueryResponse) => {
        if (error) {
          throw error;
        }
        const parsedData = parseResponse(data);
        if (!loading) {
          const isValidProduct =
            Boolean(parsedData) &&
            Boolean(parsedData!.product) &&
            Boolean(parsedData!.product!.active);
          if (!isValidProduct) {
            throw new NotFoundError();
          }
        }
        return (
          <Provider
            value={{
              loading,
              ...parsedData
            }}
          >
            {children}
          </Provider>
        );
      }}
    </Query>
  );
};
